import { useState } from "react";
import { useSelector } from "react-redux";

import {
  IconArticle,
  IconJournalism,
  IconDocument,
  IconPodcast,
  IconVideo,
  IconBook,
} from "./Icons";
import { isFes } from "../../utils/diffentLayoutCheck";
const hideSummaryButton = Boolean(process.env.REACT_APP_HIDE_SUMMARY) || false;
const channelIndex = process.env.REACT_APP_PROJECT_INDEX || undefined;

const mapIcons = {
  ARTICLE: <IconArticle />,
  JOURNALISM: <IconJournalism />,
  DOCUMENT: <IconDocument />,
  PODCAST: <IconPodcast />,
  VIDEO: <IconVideo />,
  BOOK: <IconBook />,
};
const ArchiveCard = ({ article }) => {
  const bookmarksList = useSelector((state) => state.search.bookmarks);
  const [showAbstract, setShowAbsctract] = useState(false);

  const iFrameParentUrl =
    window.location !== window.parent.location
      ? document?.referrer
      : document?.location?.href;
      const isCorrectParent =
      iFrameParentUrl === "https://www.the-syllabus.com/" ||
      iFrameParentUrl === "https://www.the-syllabus.com" ||
      iFrameParentUrl === "http://localhost:3000";
  const showBookmarks = isCorrectParent && channelIndex && channelIndex === 'syllabus';
  const isInBookmarks = bookmarksList.length
    ? bookmarksList.some((b) => b.linkId === article.linkId)
    : false;
  const bookMarkStrokeColor = isInBookmarks ? "#fff" : "#A4A4A4";
  const bookMarkLineColor = isInBookmarks ? "#fff" : "#A4A4A4";
  const bookMarkFillColor = isInBookmarks ? "#0000FF" : "white";
  const bookMarksPostMessage = (id) => {
    // console.log('bookMarksPostMessage:', id)
    if (id) {
      window.parent.postMessage({ type: "bkmrk", id: id }, "*");
    }
  };
  return (
    <article className="w-full flex flex-col-reverse lg:flex-row text-left justify-between py-6 min-h-36 border-b-[1px] border-b-black border-dotted lg:pr-20">
      {!isFes() && (
        <div className="flex flex-col tex-base lg:w-1/4">
          <div className="sui-result__authors">{article.authors}</div>
          <div className="italic">{article.publicationName}</div>
        </div>
      )}
      <div
        className={`flex flex-col items-start ${
          isFes() ? "w-full" : "lg:w-3/4 lg:pl-5"
        } `}
      >
        <div
          className={`block ${
            isFes()
              ? "mb-2 text-primary hover:opacity-70"
              : "mb-6 hover:text-primary"
          }`}
        >
          <span className="type-icon pt-2 pr-2 inline-block">
            {mapIcons[article.contentType.toUpperCase()]}
          </span>
          <a
            href={article.externalUrl}
            target="_blank"
            rel="noreferrer"
            title={article.itemTitle}
            className="pr-2 text-card-title font-bold leading-7"
          >
            {article.itemTitle}
          </a>
        </div>
        {isFes() && (
          <div className="flex flex-col tex-base w-full mb-2 opacity-70">
            <div className="sui-result__authors">{article.authors}</div>
            <div className="italic">{article.publicationName}</div>
          </div>
        )}
        {showAbstract && (
          <p className="text-base mb-2">{article.abstractDescription}</p>
        )}
        {article.abstractDescription?.length && !hideSummaryButton ? (
          <div
            className="underline font-bold mb-2 text-xs cursor-pointer hover:opacity-50 "
            onClick={() => setShowAbsctract(!showAbstract)}
          >
            {showAbstract ? "Close summary" : "Show summary"}
          </div>
        ) : null}
      </div>
      {showBookmarks && (
        <div
          className="flex flex-row items-center cursor-pointer self-start"
          onClick={() => bookMarksPostMessage(article.linkId)}
        >
          <svg
            width="16"
            height="21"
            viewBox="0 0 16 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 20.5196C1 20.6687 1.17806 20.7407 1.27684 20.6316L6.43002 14.9385C6.46134 14.9063 6.50706 14.8846 6.55597 14.8846C6.60488 14.8846 6.65027 14.906 6.68544 14.9421L11.8492 20.6359C11.9483 20.745 12.126 20.673 12.126 20.5238V4.52076C12.126 4.43006 12.0544 4.35645 11.9662 4.35645H1.15984C1.07161 4.35645 1 4.43006 1 4.52076V20.5196Z"
              stroke={bookMarkStrokeColor}
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={bookMarkFillColor}
            />
            <circle
              cx="12.1263"
              cy="4.35615"
              r="3.2624"
              transform="rotate(90 12.1263 4.35615)"
              fill={bookMarkFillColor}
              stroke={bookMarkStrokeColor}
              strokeWidth="0.5"
            />
            <line
              x1="14.3335"
              y1="4.33008"
              x2="9.91826"
              y2="4.33008"
              stroke={bookMarkLineColor}
              strokeWidth="0.5"
            />
            <line
              x1="12.1211"
              y1="6.56348"
              x2="12.1211"
              y2="2.14824"
              stroke={bookMarkLineColor}
              strokeWidth="0.5"
            />
          </svg>
          {isInBookmarks ? null : (
            <div className="text-xs uppercase color-[#a4a4a4] ml-1">
              Add to bookmarks
            </div>
          )}
        </div>
      )}
    </article>
  );
};

export default ArchiveCard;
